import { ValueOf } from 'types/util';

// shared
export enum SrpFilterName {
  MakeModel = 'MakeModel',
  Year = 'Year',
  Condition = 'Condition',
  Cylinders = 'Cylinders',
  Radius = 'Radius',
  SortBy = 'SortBy',
  Price = 'Price',
}

export type SrpFilterRangeValue = {
  min: number;
  max: number;
};

// make+model
export interface MakeModel {
  make?: string;
  model?: string;
}

// condition
export type SrpConditionFilterValue = Partial<Record<SrpConditionName, boolean>>;

export type SrpConditionName = 'new' | 'used' | 'certified pre-owned' | 'includes_warranty';

// cylinders
export type SrpCylindersFilterValue = Partial<Record<SrpCylinderCount, boolean>>;

export type SrpCylinderCount = 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12;

// radius
export interface RadiusParams {
  number: number;
}

export type SrpRadiusFilterValue = RadiusParams;

// price
export interface SrpPriceFilterParams {
  name: SrpFilterName.Price;
  value: SrpPriceFilterValue;
}

export type SrpPriceFilterValue = Partial<{
  hideNoPriceListings: boolean;
}>;

//
// state
//
export interface SrpFiltersState {
  initialized: boolean;
  values: SrpFilterValues;
}

export interface SrpFilterValues {
  [SrpFilterName.MakeModel]: MakeModel;
  [SrpFilterName.Year]: SrpFilterRangeValue;
  [SrpFilterName.Condition]: SrpConditionFilterValue;
  [SrpFilterName.Cylinders]: SrpCylindersFilterValue;
  [SrpFilterName.Radius]: SrpRadiusFilterValue;
  [SrpFilterName.SortBy]: string | undefined;
  [SrpFilterName.Price]: SrpPriceFilterValue;
}

export type SrpFilterValue = ValueOf<SrpFilterValues>;
